import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    
    // También guardar el token con la clave X-TOKEN si existe
    if (auth.api_token) {
      setTokenInStorage(auth.api_token)
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    // También remover el token X-TOKEN para mantener consistencia
    removeTokenFromStorage()
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

// Función auxiliar para configurar el token en localStorage
const setTokenInStorage = (token: string) => {
  if (localStorage) {
    localStorage.setItem('X-TOKEN', token)
  }
}

// Función auxiliar para obtener el token desde localStorage
const getTokenFromStorage = (): string | null => {
  if (localStorage) {
    return localStorage.getItem('X-TOKEN')
  }
  return null
}

// Función auxiliar para remover el token desde localStorage
const removeTokenFromStorage = () => {
  if (localStorage) {
    localStorage.removeItem('X-TOKEN')
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  
  // Interceptor para requests - agregar token X-TOKEN
  axios.interceptors.request.use(
    (config: {headers: {['X-TOKEN']: string}}) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers['X-TOKEN'] = auth.api_token
        setTokenInStorage(auth.api_token) // Guardar también en localStorage independiente
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
  
  // Interceptor para responses - manejar errores de autenticación
  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      if (error.response?.status === 401) {
        // Token expirado o inválido
        removeAuth()
        removeTokenFromStorage()
        window.location.href = '/auth/login'
      }
      return Promise.reject(error)
    }
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY, setTokenInStorage, getTokenFromStorage, removeTokenFromStorage}
